// Iter 90h — Security state chip moved from the Dashboard toolbar to the
// global top nav (between the theme toggle and the user menu).
//
// Hidden entirely when `/security/status` returned 403 (partner /
// customer scopes get no chip). Clicking navigates the caller to the
// Security tab of Settings.
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const VERDICT_META = {
  pass:        { label: "Security ✓", bg: "bg-emerald-50",  fg: "text-emerald-700",  ring: "ring-emerald-200"  },
  conditional: { label: "Security ⚠", bg: "bg-amber-50",    fg: "text-amber-700",    ring: "ring-amber-200"    },
  fail:        { label: "Security ✗", bg: "bg-rose-50",     fg: "text-rose-700",     ring: "ring-rose-200"     },
};

export function SecurityBadge() {
  const [status, setStatus] = useState(null);
  const navigate = useNavigate();
  // Iter 114u — explicit permission gate; no fetch without `security.view`.
  const { has } = useAuth();
  const canView = has("security.view");

  useEffect(() => {
    if (!canView) return;
    let cancelled = false;
    api.get("/security/status")
      .then((r) => { if (!cancelled) setStatus(r.data); })
      .catch(() => { if (!cancelled) setStatus(null); });
    return () => { cancelled = true; };
  }, [canView]);

  if (!canView) return null;
  if (!status) return null;
  const v = (status.verdict || "unknown").toLowerCase();
  const meta = VERDICT_META[v] || {
    label: "Security ?", bg: "bg-slate-50", fg: "text-slate-600", ring: "ring-slate-200",
  };
  const when = status.ran_at ? new Date(status.ran_at).toLocaleDateString() : "—";

  return (
    <button
      type="button"
      onClick={() => navigate("/settings?tab=security")}
      data-testid="topnav-security-badge"
      title={`Last audit: ${when} · ${status.summary || ""}`}
      className={`inline-flex items-center gap-1 rounded-full ${meta.bg} ${meta.fg} px-2.5 py-1 text-[11px] font-semibold ring-1 ${meta.ring} hover:brightness-95 transition`}
    >
      <ShieldCheck className="h-3 w-3" /> {meta.label}
    </button>
  );
}
